import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';

import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Button,
  TableContainer,
  TablePagination,
  Typography
} from '@material-ui/core';

import moment from 'moment';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { baseUrl } from '../../utils/constants';
import { useClaimsContext } from '../../context/claims_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';
import ClaimStatusesSub from './ClaimStatusesSub';
import { useSettingContext } from '../../context/setting_context';
// import ClaimsLine from './ClaimsLine';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'claim', label: 'Claim Code', alignRight: false },
  { id: 'Claimcode', label: 'Description', alignRight: false },
  { id: 'claim status', label: 'Status', alignRight: true },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClaimStatuses() {
  const [page, setPage] = useState(0);
  const { setCycleId, setCycle, initializeCycle } = useSettingContext();
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [subItemId, setSubItemId] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    getClaimStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getClaimStatuses = () => {
    fetch(`${baseUrl}/api/Setting/GetClaimsStatuses`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('claim statuses list', result);
          setDataList(result);
        },
        (error) => {
          notifyPopup(`Error in Retrieving Claim Statuses!: ${error}`, 'error');
        }
      );
  };

  //   const handleLineView = (e) => {
  //     console.log('e claimLineId ', e);
  //     refreshClaimLineById(e.claimDtl_id);
  //     openView();
  //   };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const openNew = (e) => {
    setCycleId(0);
    initializeCycle();
    setOpenPopup(true);
  };

  const openView = (e) => {
    setOpenPopup(true);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h4" gutterBottom>
          Claim Statuses
        </Typography>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => openNew()}
        >
          Create New Claim Status
        </Button>
      </Stack>
      <Card>
        <Scrollbar>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const { claiM_STATUS, claimCode, claimstatuS_ID } = row;
                    const isItemSelected = selected.indexOf(claimstatuS_ID) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={claimstatuS_ID}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{claiM_STATUS}</TableCell>
                        <TableCell align="left">{claimCode}</TableCell>
                        <TableCell align="right">{claimstatuS_ID}</TableCell>
                        {/* <TableCell align="right">
                          <IconButton onClick={() => handleLineView({ errorID })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.Popup title="Claim Statuses" openPopup={openPopup} setOpenPopup={setOpenPopup}>
            <ClaimStatusesSub closePopup={closePopup} id={subItemId} />
          </Controls.Popup>
          {/* <Controls.Popup title="Add Detail Line" openPopup={openPopup} setOpenPopup={setOpenPopup}>
            <ClaimsLine closePopup={closePopup} claim_ID={claimNo} />
          </Controls.Popup> */}
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
